import styled from 'styled-components'

const Content = styled.main`
    position: relative;
    padding: 2em 2em 10em 2em;
  `

export { Content }



// WEBPACK FOOTER //
// ./src/Components/Feed/styles.js